module.exports = __webpack_public_path__ + "static/media/saudeprime.9e9ac851.png";